// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IbpK","field":"styles_field__2Mlan","fieldCol":"styles_fieldCol__3itHm","diffCol":"styles_diffCol__3DaxK","diff":"styles_diff__2ZTK2"};